import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container flex h-full flex-col items-start justify-between overflow-y-auto overflow-x-hidden pb-4 pt-28 lg:overflow-hidden lg:py-40" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute hidden h-full lg:block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute left-0 top-0 origin-left -translate-x-56 rotate-90 font-serif uppercase text-sun lg:text-huge lg:leading-[0px]" }, " rize ")
], -1)
const _hoisted_3 = { class: "flex w-full" }
const _hoisted_4 = { class: "mx-1" }
const _hoisted_5 = {
  key: 1,
  class: "flex w-full justify-end gap-x-2 lg:hidden"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "hidden" }

import { computed, ref } from 'vue';
import { useNavigation } from '@/composables/useNavigation';
import events from '@/events';
import LzIcon from '@/components/base/LzIcon.vue';

interface LangItem {
    label: string;
    link: string;
    active: boolean;
}

const ANIM_TIME = 250;

export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavigation',
  props: {
    isHome: { type: Boolean },
    contrast: { type: Boolean },
    currentSite: {},
    langNav: {}
  },
  setup(__props: any) {

const props = __props;


// generic navigation logic comes from composable
const { currentItem, hasBack, isTop, isOpen, showNavi, navigate, back, toggle } = useNavigation();

// project specific stuff
const showSiteNav = ref(false);
const siteNavIndex = ref(0);
const showItems = ref(false);
const isBack = ref(false);
const sunrizeSlide = ref(true);
const logoColor = computed(() => {
    if (props.contrast && isOpen.value) {
        return 'text-white';
    }
    if (!isTop.value || isOpen.value) {
        return 'text-black';
    }
    return props.isHome
        ? sunrizeSlide.value
            ? 'text-moon'
            : 'text-white'
        : props.contrast
        ? 'text-white'
        : 'text-black';
});
const buttonColor = computed(() => {
    if (!isTop.value || isOpen.value) {
        return `${
            props.contrast && isOpen.value ? 'text-white lg:text-black' : 'text-black'
        } lg:hover:bg-black lg:hover:text-white lg:hover:border-black`;
    }
    return props.isHome
        ? sunrizeSlide.value
            ? 'text-white border-white lg:text-moon lg:border-moon lg:hover:bg-moon lg:hover:text-white 2xl:hover:bg-white 2xl:hover:text-black 2xl:text-white 2xl:border-white'
            : 'text-black border-black lg:text-white lg:border-white lg:hover:bg-white lg:hover:text-black 2xl:hover:bg-black 2xl:hover:text-white 2xl:text-black 2xl:border-black'
        : props.contrast
        ? 'text-white border-white lg:hover:bg-white lg:hover:text-black'
        : 'text-black border-black lg:hover:bg-black lg:hover:text-white';
});
const bgColor = computed(() => {
    const classes = [
        isTop.value && !isOpen.value
            ? 'bg-transparent'
            : props.contrast && isOpen.value
            ? 'bg-moon'
            : 'bg-white'
    ];
    if (isTop.value || isOpen.value) {
        classes.push('lg:bg-transparent');
    }
    return classes.join(' ');
});

events.$on('stage-slide', ({ sunrize }) => {
    sunrizeSlide.value = sunrize;
});

// temporarily hide nav items for animation
function itemClicked(index: number) {
    isBack.value = false;
    showItems.value = false;
    setTimeout(() => {
        navigate(index);
        showItems.value = true;
    }, ANIM_TIME);
}

function backClicked() {
    isBack.value = true;
    showItems.value = false;
    setTimeout(() => {
        back();
        showItems.value = true;
    }, ANIM_TIME);
}

function toggleSiteNav() {
    isBack.value = showSiteNav.value;
    if (showSiteNav.value) {
        showSiteNav.value = false;
        siteNavIndex.value = 0;
        setTimeout(() => {
            showItems.value = true;
        }, ANIM_TIME);
    } else {
        showItems.value = false;
        setTimeout(() => {
            showSiteNav.value = true;
        }, ANIM_TIME);
    }
}

function selectSiteNav(index: number) {
    siteNavIndex.value = index;
}

function toggleMenu() {
    isBack.value = !isOpen.value;
    if (isOpen.value) {
        showItems.value = false;
        showSiteNav.value = false;
        siteNavIndex.value = 0;
        setTimeout(() => {
            toggle();
            document.body.classList.toggle('overflow-hidden', isOpen.value);
        }, ANIM_TIME);
    } else {
        toggle();
        document.body.classList.toggle('overflow-hidden', isOpen.value);
        setTimeout(() => {
            showItems.value = true;
        }, ANIM_TIME);
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", {
      logoColor: logoColor.value,
      buttonColor: buttonColor.value,
      isTop: _unref(isTop),
      isOpen: _unref(isOpen),
      bgColor: bgColor.value,
      showNavi: _unref(showNavi),
      toggleSiteNav: toggleSiteNav,
      toggle: toggleMenu,
      langNav: _ctx.langNav
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["fixed left-0 top-0 z-40 h-screen w-full overflow-hidden transition-all duration-700", [
            _unref(isOpen) ? 'max-h-screen' : 'max-h-0',
            _ctx.contrast ? 'bg-moon text-white' : 'bg-white'
        ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _renderSlot(_ctx.$slots, "nav", {
          back: backClicked,
          item: _unref(currentItem),
          showItems: showItems.value,
          hasBack: _unref(hasBack),
          isBack: isBack.value,
          contrast: _ctx.contrast,
          navigate: itemClicked
        }),
        _renderSlot(_ctx.$slots, "teaser", {
          show: !showSiteNav.value
        }),
        _createVNode(_Transition, { name: "slide-bottom-to-top" }, {
          default: _withCtx(() => [
            (showSiteNav.value)
              ? _renderSlot(_ctx.$slots, "sitenav", {
                  key: 0,
                  toggle: toggleSiteNav,
                  index: siteNavIndex.value,
                  select: selectSiteNav
                })
              : _createCommentVNode("", true)
          ]),
          _: 3
        }),
        _createElementVNode("div", _hoisted_3, [
          (!showSiteNav.value && showItems.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "flex items-center lg:hidden",
                onClick: toggleSiteNav
              }, [
                _createVNode(LzIcon, {
                  name: "sites",
                  class: "h-5 w-5 fill-current"
                }),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentSite), 1),
                _createVNode(LzIcon, {
                  name: "chevron",
                  class: "h-5 w-5 rotate-90"
                })
              ]))
            : _createCommentVNode("", true),
          (_unref(isOpen) && _ctx.langNav.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langNav, (langItem, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: langItem.link
                  }, [
                    (langItem.active)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass([_ctx.contrast ? 'text-white' : 'text-moon'])
                        }, _toDisplayString(langItem.label), 3))
                      : (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: langItem.link,
                          class: _normalizeClass([
                                _ctx.contrast
                                    ? 'text-white/50 hover:text-sun'
                                    : 'text-gray-400 hover:text-purple-300'
                            ])
                        }, _toDisplayString(langItem.label.replace(/_.*$/, '')), 11, _hoisted_6)),
                    (index < _ctx.langNav.length - 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: _normalizeClass([_ctx.contrast ? 'text-white/50' : 'text-moon'])
                        }, "|", 2))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "registration")
    ])
  ], 64))
}
}

})